export const can = (functionality: string, access: string[]) => access.includes(functionality);

export const canAny = (functionality: string[], access: string[]) => functionality.some((func) => can(func,access ));
